import { threeDStudioStore } from '../index'

const setImageSettings = (patch) => {
  threeDStudioStore.setState(state => ({
    imageSettings: { ...state.imageSettings, ...patch },
  }))
}

/**
 * Sets the image provider the composer locks its runs to.
 * @param {string} modelId - PROVIDER.FLUX or PROVIDER.NANO_BANANA
 */
export const setModelId = (modelId) => {
  setImageSettings({ modelId })
}

/**
 * Sets the aspect ratio of the generated images.
 * @param {string} aspectRatio - One of IMAGE_ASPECT_RATIOS
 */
export const setAspectRatio = (aspectRatio) => {
  setImageSettings({ aspectRatio })
}

/**
 * Sets how many images a run generates.
 * @param {number} variations
 */
export const setVariations = (variations) => {
  setImageSettings({ variations })
}
